import { __read, __awaiter, __generator } from 'tslib';
import React__default from 'react';
import { CartContext } from '../../../context/CartContext.esm.js';
import { useAnalyticsQueue } from '@invitae/analytics-queue';
import { NvModal } from '@invitae/ids-react';
import { OrderGroupProductTypeEnum, CustomPanelCreationResponseOutcomeEnum } from '@invitae/stargate-ts-fetch';
import Input from '../../../components/fields/Input/Input.esm.js';
import { AnalyticsEventName } from '../../../constants/analytics.esm.js';
import { UNEXPECTED_SERVER_ERROR } from '../../../constants/api.esm.js';
import { NAME_ALREADY_EXISTS, RNA_CUSTOM_ORDER_MESSAGE, INPUT_PLACEHOLDER } from '../../../constants/customOrder.esm.js';
import styles from './SaveCustomOrderModal.module.esm.js';
import modalStyles from '../../ModalBuilder.module.esm.js';

var SaveCustomOrderModal = function (_a) {
    var concepts = _a.concepts, onClose = _a.onClose, _b = _a.productType, productType = _b === void 0 ? OrderGroupProductTypeEnum.Unknown : _b;
    var _c = __read(React__default.useState(''), 2), panelName = _c[0], setPanelName = _c[1];
    var _d = __read(React__default.useState(''), 2), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = __read(React__default.useState(false), 2), panelSaved = _e[0], setPanelSaved = _e[1];
    var saveCustomPanel = React__default.useContext(CartContext).saveCustomPanel;
    var logEvent = useAnalyticsQueue().logEvent;
    var logSavedCustomOrderEvent = React__default.useCallback(function (eventName) {
        logEvent({
            eventName: eventName,
            eventProperties: {
                Concepts: concepts,
                'Product type': productType,
            },
        });
    }, [concepts, logEvent, productType]);
    var onPanelNameChange = function (event) {
        if (errorMessage)
            setErrorMessage('');
        setPanelName(event.target.value);
    };
    var onCloseHandler = React__default.useCallback(function () {
        if (!panelSaved) {
            logSavedCustomOrderEvent(AnalyticsEventName.CanceledSavingCustomOrder);
        }
        setPanelName('');
        onClose(panelSaved);
        setPanelSaved(false);
    }, [logSavedCustomOrderEvent, onClose, panelSaved]);
    var onSaveHandler = React__default.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!panelName)
                        return [2 /*return*/];
                    return [4 /*yield*/, saveCustomPanel(concepts, panelName)];
                case 1:
                    response = (_a.sent());
                    if ((response === null || response === void 0 ? void 0 : response.outcome) === CustomPanelCreationResponseOutcomeEnum.Success) {
                        setPanelSaved(true);
                    }
                    if ((response === null || response === void 0 ? void 0 : response.outcome) === CustomPanelCreationResponseOutcomeEnum.PanelWithThisNameAlreadyExists) {
                        setErrorMessage(NAME_ALREADY_EXISTS);
                    }
                    else if (!(response === null || response === void 0 ? void 0 : response.outcome)) {
                        setErrorMessage(UNEXPECTED_SERVER_ERROR);
                    }
                    logSavedCustomOrderEvent(AnalyticsEventName.SavedCustomOrder);
                    return [2 /*return*/];
            }
        });
    }); }, [concepts, logSavedCustomOrderEvent, panelName, saveCustomPanel]);
    return (React__default.createElement(NvModal, { classes: { modal: modalStyles.modal }, defaultOpen: true, headerText: "Save custom order for future use", onDismiss: onCloseHandler, onPrimaryButtonClicked: panelSaved ? onCloseHandler : onSaveHandler, onSecondaryButtonClicked: onCloseHandler, primaryButtonDisabled: !panelName || errorMessage === NAME_ALREADY_EXISTS, primaryButtonText: panelSaved ? 'Close' : 'Save', secondaryButtonText: panelSaved ? '' : 'Cancel', showCloseButton: true, type: "information" }, !panelSaved ? (React__default.createElement(React__default.Fragment, null,
        productType === OrderGroupProductTypeEnum.DiagnosticRna && (React__default.createElement("p", { className: styles.rnaCustomOrderMessage }, RNA_CUSTOM_ORDER_MESSAGE)),
        React__default.createElement(Input, { autoFocus: true, onChange: onPanelNameChange, placeholder: INPUT_PLACEHOLDER }),
        errorMessage && React__default.createElement("div", { className: styles.errorMessage }, errorMessage))) : (React__default.createElement("p", null,
        "Custom order \"",
        panelName,
        "\" successfully saved."))));
};

export { SaveCustomOrderModal as default };
//# sourceMappingURL=SaveCustomOrderModal.esm.js.map
